import React, { Fragment, useCallback, useState } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { TD } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';
import Edit from './Edit';

const ViewList = ({ material, index }) => {
  const [showEditModel, setShowEditModel] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);

  // Format: dd-mm-yyyy (matches your previous en-GB with dashes)
  const formatDate = useCallback((d) => {
    if (!d) return '-';
    try {
      return new Date(d)
        .toLocaleDateString('en-GB')
        .replace(/\//g, '-');
    } catch {
      return '-';
    }
  }, []);

  const canManage = checkPermission(
    [permissions.manage_masters, permissions.manage_product_master, permissions.manage_stencil_menu],
    currentUser
  );

  return (
    <Fragment>
      <tr className={index % 2 !== 0 ? 'bg-gray-50' : ''}>
        <TD>{index+1}</TD>
        <TD>{material?.tyreSize || '-'}</TD>
        <TD>{material?.skuName || '-'}</TD>
        <TD>{material?.materialDescription || '-'}</TD>
        <TD>{material?.originalNsd ?? '-'}</TD>
        <TD>{material?.updatedByName || material?.updatedBy || '-'}</TD>
        <TD>{formatDate(material?.createdAt)}</TD>
        <TD>
          {canManage ? (
            <div className="flex items-center">
              <button
                type="button"
                onClick={() => setShowEditModel(true)}
                onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setShowEditModel(true)}
                className="p-2 m-1 rounded-md bg-green-500 hover:bg-green-600 text-white"
                title="Edit"
                aria-label="Edit"
              >
                <FaEdit />
              </button>
            </div>
          ) : (
            <span className="text-gray-400">----</span>
          )}
        </TD>
      </tr>

      {showEditModel && (
        <Edit data={material} handleClick={() => setShowEditModel(false)} />
      )}
     
    </Fragment>
  );
};

export default ViewList;
